import gql from 'graphql-tag';

export const GET_USER_IDENTITY = gql`
  query getUserIdentity {
    identity {
      currentAdmin {
        id
        name
      }
      currentConcierge {
        id
        name
        email
      }
    }
  }
`;
